// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"nZ-z","sponsoredTooltipWrapper":"oZ-z","sponsoredTooltip":"pZ-z","newCard":"qZ-z"};